import type { IconSvgObject } from './types';

const HandPointingLeft04Icon: IconSvgObject = [
  ["path", { d: "M12.3546 14H10.5C9.67157 14 9 13.3284 9 12.5V11M13 17H11.5C10.6716 17 10 16.3284 10 15.5V14.2328M9 11L11.4211 11M14 8L9 8H4C3.17157 8 2.5 8.67157 2.5 9.5C2.5 10.3284 3.17157 11 4 11H9M11 17.3237V18.5C11 19.3284 11.6716 20 12.5 20H18.5C20.1569 20 21.5 18.6569 21.5 17V9.60555C21.5 8.60249 20.9987 7.6658 20.1641 7.1094L16.2558 4.50385C15.763 4.17531 15.1839 4 14.5917 4H14.2426C13.447 4 12.6839 4.31607 12.1213 4.87868L9 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default HandPointingLeft04Icon;
